import { useMemo } from 'react'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'

export const useIrrigationZoneNameDictionary = (
  irrigationZoneEmitters: TProperty['irrigationZoneEmitters'],
): Record<number, string> => {
  return useMemo(
    () =>
      Object.fromEntries(
        Object.values(irrigationZoneEmitters ?? {}).map(({ irrigationZoneId, name }) => [
          irrigationZoneId,
          name,
        ]),
      ),
    [irrigationZoneEmitters],
  )
}
